export const PartnerTier = {
  NONE: "Not Included",
  AUTHORIZED: "Authorized",
  GOLD: "Gold",
  PLATINUM: "Platinum",
} as const;
export type PartnerTierType = (typeof PartnerTier)[keyof typeof PartnerTier];

export interface PartnerTierBenefit {
  baseDiscount: number;
  softwareDiscount: number;
  yearEndBonus: number;
  leadForwardingBonus: number;
}

// TODO: These could be inferred from zod schemas, and the schemas could be used for validation
export interface IPartnerInfo {
  partnerId: string;
  partnerName: string;
  phoneNumber: string;
  address: string;
  address2?: string;
  zipCode: string;
  city: string;
  country: string;
  contactPerson: IContactPerson;
  paymentTermsCode: string;
  priceListAreaCode: string;
  productGroups: IProductGroup[];
  hasFreeHandling: boolean;
  blockedActivities: string[];
  visitingStreetAddress?: string;
  visitingZipCode?: string;
  visitingCity?: string;
  partnerTier?: PartnerTierType;
  benefits?: Record<PartnerTierType, PartnerTierBenefit>;
  currencyCode: string;
}

export interface IContactPerson {
  name: string;
  email: string;
  profile?: IContactPersonProfile;
}

export interface IContactPersonProfile {
  mobilePhone: string;
  photo: string;
}

export interface IProductGroup {
  code: string;
  itemCategories: string[];
}
